<template>
    <div class="top-menu">
        <div class="searchbar">
            <form action="." class="animated fadeIn" @submit.prevent="doSearch()" v-if="!$store.state.searching">
                <input type="search" class="hero-search" placeholder="AL 52 114" maxlength="9" v-model="$store.state.licenseplate" />
                <!--<br><br>
                <button type="submit" class="animated fadeIn delay-2s">
                    Søg
                </button>-->
                <br><br>
                <div class="vehicle-header animated zoomIn" v-if="$store.state.match">
                    <div class="make-model">
                        {{ $store.state.carData.general.MaerkeTypeNavn }}
                        <span v-if="$store.state.carData.general.ModelTypeNavn !== 'UOPLYST' && $store.state.carData.general.ModelTypeNavn !== '-'">
                            {{ $store.state.carData.general.ModelTypeNavn }}
                        </span>
                    </div>
                    <div class="variant" v-if="$store.state.carData.general.VariantTypeNavn !== 'UOPLYST' && $store.state.carData.general.VariantTypeNavn !== '-'">
                        <span>
                            {{ $store.state.carData.general.VariantTypeNavn }}
                        </span>
                        <span v-if="$store.state.carData.general.KarrosseriTypeNavn && $store.state.carData.general.KarrosseriTypeNavn !== 'Hatchback'">
                            ({{ $store.state.carData.general.KarrosseriTypeNavn }})
                        </span>
                    </div>
                </div>
            </form>
            <div class="spinner-loader" v-if="$store.state.searching">
                <div class="loader-wrapper">
                    <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container menu-container">
            <div class="menu-wrapper">
                <router-link tag="div" :to="{name: item.link}" class="menu-item" v-for="item in menuItems" v-bind:key="item.slug" :class="{'active': item.slug === activeMenuItem}" @click="activeMenuItem = item.slug">
                    <i :class="'fal fa-' + item.icon + ' fa-fw'" />
                    {{ item.name }}
                </router-link>
            </div>
        </div>
        <div class="mobile-menu">
            <router-link tag="div" :to="{name: item.link}" class="menu-item" v-for="item in menuItems" v-bind:key="item.slug" :class="{'active': item.slug === activeMenuItem}" @click="activeMenuItem = item.slug" @click.native="$scrollToTop">
                <div class="inner">
                    <i :class="'fal fa-' + item.icon + ' fa-fw'" />
                    <br>
                    {{ item.name }}
                </div>
            </router-link>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../../styles/vars";

    .top-menu {
        background: $color--main;

        .searchbar {
            min-height: 450px;
            padding-bottom: 50px;
            // background: linear-gradient(45deg, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75)), url('/static/roads.jpeg') center bottom no-repeat;
            // background: linear-gradient(45deg, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75)), url('https://images.unsplash.com/photo-1493238792000-8113da705763?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=6150&q=80') center center no-repeat;
            background: linear-gradient(45deg, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75)), url('/static/audi_wide.jpg') center center no-repeat;
            background-size: cover;
            // background-attachment: fixed;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;

            @media screen and (max-width: $small) {
                min-height: 250px;
                padding-bottom: 0px;
            }

            .hero-search {
                font-size: 75px;
                padding-bottom: 10px;
                color: #333;
                font-family: 'Arial';
                font-weight: 900;
                background: url('/static/licenseplate4.png') center center no-repeat;
                background-size: cover;
                width: 504px;
                height: 150px;
                border: none;
                padding-left: 85px;
                padding-right: 30px;
                text-transform: uppercase;
                outline: none;
                text-align: center;

                @media screen and (max-width: $small) {
                    zoom: 50%;
                    padding-bottom: 20px;
                }

                &::placeholder {
                    color: rgba(0, 0, 0, 0.1);
                }
            }

            button {
                padding: 15px 45px;
                font-size: 20px;
                background: #fff;
                /* background: linear-gradient(to bottom right, #4256A0, #283C86); */
                background: $color--main;
                color: #fff;
                // border: 1px solid rgba(0, 0, 0, 0.15);
                border: 1px solid rgba(255, 255, 255, 0.5);
                border-radius: 100px;
                transition: .15s ease all;
                cursor: pointer;
                text-transform: uppercase;
                box-shadow: 0px 5px 15px rgba(255, 255, 255, 0.15);

                &:hover {
                    transform: translateY(-4px);
                    // background: linear-gradient(to bottom right, #283C86, #4256A0);
                    background: darken(rgb(29, 195, 174), 5%);
                }
            }

            .vehicle-header {
                color: #fff;
                text-shadow: 0 0 10px rgba(0,0,0,0.7);

                .make-model {
                    font-size: 30px;
                    font-weight: 600;
                }

                .variant {
                    font-size: 18px;
                    font-weight: 400;
                }
            }

            .spinner-loader {
                font-size: 50px;
                color: #fff;
            }
        }

        .container.menu-container {
            @media screen and (max-width: $medium) {
                width: 100%;
            }
        }

        .menu-wrapper {
            display: flex;
            // justify-content: space-between;
            justify-content: flex-start;
            transform: translate(0,-100%);

            @media screen and (max-width: $small) {
                padding-bottom: 30px;
            }

            .menu-item {
                // flex: 0 0 16.66%;
                flex: 0 0 20%;
                color: #fff;
                text-align: center;
                padding: 15px;
                border-radius: 5px 5px 0px 0px;
                // transition: 0.3s ease all;
                cursor: pointer;
                user-select: none;
                // background: #fff;
                // box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
                // opacity: .75;
                display: flex;
                justify-content: center;
                cursor: pointer;

                @media screen and (max-width: $small) {
                    display: none !important;
                }

                i {
                    font-size: 20px;
                    margin-right: 5px;
                }

                &:hover {
                    // transform: translateY(-4px);
                    background: rgba(255, 255, 255, 0.15);
                }

                &:not(.router-link-exact-active) {
                    text-shadow: 0 0 10px rgba(0,0,0,0.7);
                }

                &.router-link-exact-active {
                    background: $color--main;
                    color: #fff;
                    font-weight: 600;
                    // opacity: 1;

                    i {
                        font-weight: 900;
                    }
                }
            }
        }

        .mobile-menu {
            position: fixed;
            bottom: 0px;
            left: 0px;
            right: 0px;
            z-index: 99;
            display: flex;
            height: 70px;
            box-shadow: 0px -5px 15px rgba(0, 0, 0, .15);
            background: #fff;
            justify-content: center;

            @media screen and (min-width: $small) {
                display: none;
            }

            .menu-item {
                flex: 0 0 15%;
                flex-grow: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                font-size: 10px;
                color: $color--main;
                opacity: .5;

                i {
                    font-size: 16px;
                    margin-bottom: 4px;
                }

                &.router-link-exact-active {
                    opacity: 1;
                    font-weight: 600;

                    i {
                        font-weight: 900;
                    }
                }
            }
        }
    }

</style>

<script>
export default {
    data () {
        return {
            activeMenuItem: 'overview',
            menuItems: [
                {
                    name: 'Overblik',
                    slug: 'overview',
                    icon: 'car',
                    link: 'SearchOverview'
                },
                {
                    name: 'BilBogen',
                    slug: 'registry',
                    icon: 'book-open',
                    link: 'SearchRegistry'
                },
                {
                    name: 'Synsrapporter',
                    slug: 'reports',
                    icon: 'clipboard-list-check',
                    link: 'SearchReports'
                },
                {
                    name: 'Afgifter',
                    slug: 'charges',
                    icon: 'envelope-open-dollar',
                    link: 'SearchCharges'
                },
                /* {
                    name: 'Tidslinje',
                    slug: 'timeline',
                    icon: 'stream',
                    link: 'SearchTimeline'
                }, */
                {
                    name: 'Teknisk info',
                    slug: 'technical-info',
                    icon: 'cog',
                    link: 'SearchTechnicalInfo'
                }
            ]
        }
    },
    methods: {
        doSearch () {
            let licenseplate = this.$store.state.licenseplate.split(' ').join('')
            if (licenseplate !== '') {
                window.location.href = '/soeg/' + licenseplate + '/overblik'
            } else {
                alert('Indtast venligst en nummerplade for at søge.')
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// topmenu.vue?24d6911c